"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promotionsApiOverrideUrl = exports.pricesApiOverrideUrl = exports.partnersApiUrl = exports.ordersApiUrl = exports.paymentsPageType = exports.awinProxyUrl = exports.paymentsApiUrl = exports.brazeUKSubscriptionGroupId = exports.brazeUSSubscriptionGroupId = exports.brazeApiKey = exports.brazeProxyUrl = exports.promotionRefreshInterval = exports.facebookApiUrl = exports.leadsApiUrl = exports.atatApiUrl = exports.locale = exports.deployEnv = exports.yodaApiUrl = exports.yodaAuthDomain = exports.yodaClientId = exports.optimizelyFsSdkKey = exports.baseApiUrl = exports.siteDomain = void 0;
const constants_1 = require("./constants");
exports.siteDomain = process.env.SITE_DOMAIN || '';
exports.baseApiUrl = process.env.BASE_SS_API_URL || '';
exports.optimizelyFsSdkKey = process.env.OPTIMIZELY_FS_SDK_KEY || '';
exports.yodaClientId = process.env.YODA_CLIENT_ID || '';
exports.yodaAuthDomain = process.env.YODA_AUTH_DOMAIN || '';
exports.yodaApiUrl = process.env.YODA_API_URL || '';
exports.deployEnv = process.env.DEPLOY_ENV || 'qa';
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
exports.locale = process.env.LOCALE || 'en-GB';
exports.atatApiUrl = process.env.ATAT_API_URL || '';
exports.leadsApiUrl = process.env.LEADS_SS_API_URL || exports.baseApiUrl;
exports.facebookApiUrl = `${exports.baseApiUrl}/proxy/v1/facebook`;
exports.promotionRefreshInterval = process.env.PROMOTION_REFRESH_INTERVAL || constants_1.promotionRefreshIntervalFallback.toString();
exports.brazeProxyUrl = `${exports.baseApiUrl}/proxy/v1/braze`;
exports.brazeApiKey = process.env.BRAZE_API_KEY || '';
exports.brazeUSSubscriptionGroupId = process.env.BRAZE_SMS_GROUP_US_ID;
exports.brazeUKSubscriptionGroupId = process.env.BRAZE_SMS_GROUP_UK_ID;
exports.paymentsApiUrl = process.env.PAYMENTS_API_URL || `${exports.baseApiUrl}/payment-decorator`;
exports.awinProxyUrl = `${exports.baseApiUrl}/proxy/v1/awin`;
exports.paymentsPageType = process.env.PAYMENTS_PAGE_TYPE || '';
exports.ordersApiUrl = process.env.ORDERS_API_URL || `${exports.baseApiUrl}/orders`;
exports.partnersApiUrl = `${exports.baseApiUrl}/partnerships`;
exports.pricesApiOverrideUrl = process.env.PRICES_API_OVERRIDE_URL || '';
exports.promotionsApiOverrideUrl = process.env.PROMOTIONS_API_OVERRIDE_URL || '';
//# sourceMappingURL=config.js.map